import { EmployeeDatesFormat } from "@/types/organization.types.ts";
import { DateFormatConfiguration } from "@skailer-com/uikit";

export const getTimeId = (date: Date): string => {
  return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
};

export const getDateId = (date: Date): string => {
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
};

export const getDateConfiguration = (dateFormat: EmployeeDatesFormat): DateFormatConfiguration => {
  return {
    [EmployeeDatesFormat.yyyy_mm_dd]: {
      pattern: "Y/`m/`d",
      placeholder: "common:date_placeholder_yyyy_mm_dd",
      format(date: Date | null): string {
        if (!date) return "";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear());
        return `${year}/${month}/${day}`;
      },
      parse(str: string): Date {
        const [yearStr, monthStr, dayStr] = str.split("/");
        const day = parseInt(dayStr, 10);
        const month = parseInt(monthStr, 10) - 1; // В JS месяцы с 0
        const year = parseInt(yearStr, 10);
        return new Date(year, month, day);
      },
    },
    [EmployeeDatesFormat.dd_mm_yyyy]: {
      pattern: "d/`m/`Y",
      placeholder: "common:date_placeholder_dd_mm_yyyy",
      format(date: Date | null): string {
        if (!date) return "";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear());
        return `${day}/${month}/${year}`;
      },
      parse(str: string): Date {
        const [dayStr, monthStr, yearStr] = str.split("/");
        const day = parseInt(dayStr, 10);
        const month = parseInt(monthStr, 10) - 1; // В JS месяцы с 0
        const year = parseInt(yearStr, 10);
        return new Date(year, month, day);
      },
    },
    [EmployeeDatesFormat.dd_mm_yyyy_dot]: {
      pattern: "d.`m.`Y",
      placeholder: "common:date_placeholder_dd_mm_yyyy_dot",
      format(date: Date | null): string {
        if (!date) return "";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear());
        return `${day}.${month}.${year}`;
      },
      parse(str: string): Date {
        const [dayStr, monthStr, yearStr] = str.split(".");
        const day = parseInt(dayStr, 10);
        const month = parseInt(monthStr, 10) - 1; // В JS месяцы с 0
        const year = parseInt(yearStr, 10);
        return new Date(year, month, day);
      },
    },
    [EmployeeDatesFormat.mm_dd_yyyy]: {
      pattern: "m/`d/`Y",
      placeholder: "common:date_placeholder_mm_dd_yyyy",
      format(date: Date | null): string {
        if (!date) return "";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear());
        return `${month}/${day}/${year}`;
      },
      parse(str: string): Date {
        const [monthStr, dayStr, yearStr] = str.split("/");
        const day = parseInt(dayStr, 10);
        const month = parseInt(monthStr, 10) - 1; // В JS месяцы с 0
        const year = parseInt(yearStr, 10);
        return new Date(year, month, day);
      },
    },
  }[dateFormat];
};

export const isMoreThanYearAgo = (date: Date): boolean =>
  new Date(date).getTime() < Date.now() - 365 * 24 * 60 * 60 * 1000;
